/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Dialab API
 * OpenAPI spec version: 0.1
 */
import { HttpClient, HttpHeaders, HttpResponse as AngularHttpResponse } from '@angular/common/http';
import type { HttpContext, HttpEvent, HttpParams } from '@angular/common/http';

import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import type {
  CompleteOnboarding201,
  GetMe200,
  Logout201,
  OnboardingRequestDto,
  RefreshSession200,
  SsoLogin201,
  SsoRequestDto,
  TestLogin201,
  TestLoginAvailability200,
  TestLoginRequestDto,
} from '../../model';

interface HttpClientOptions {
  readonly headers?: HttpHeaders | Record<string, string | string[]>;
  readonly context?: HttpContext;
  readonly params?:
    HttpParams | Record<string, string | number | boolean | Array<string | number | boolean>>;
  readonly reportProgress?: boolean;
  readonly withCredentials?: boolean;
  readonly credentials?: RequestCredentials;
  readonly keepalive?: boolean;
  readonly priority?: RequestPriority;
  readonly cache?: RequestCache;
  readonly mode?: RequestMode;
  readonly redirect?: RequestRedirect;
  readonly referrer?: string;
  readonly integrity?: string;
  readonly referrerPolicy?: ReferrerPolicy;
  readonly transferCache?: { includeHeaders?: string[] } | boolean;
  readonly timeout?: number;
}

type HttpClientBodyOptions = HttpClientOptions & {
  readonly observe?: 'body';
};

type HttpClientEventOptions = HttpClientOptions & {
  readonly observe: 'events';
};

type HttpClientResponseOptions = HttpClientOptions & {
  readonly observe: 'response';
};

type HttpClientObserveOptions = HttpClientOptions & {
  readonly observe?: 'body' | 'events' | 'response';
};

@Injectable({ providedIn: 'root' })
export class AuthService {
  private readonly http = inject(HttpClient);
  /**
   * @summary Exchange a LIV access token for a Dialab JWT
   */
  ssoLogin<TData = SsoLogin201>(
    ssoRequestDto: SsoRequestDto,
    options?: HttpClientBodyOptions,
  ): Observable<TData>;
  ssoLogin<TData = SsoLogin201>(
    ssoRequestDto: SsoRequestDto,
    options?: HttpClientEventOptions,
  ): Observable<HttpEvent<TData>>;
  ssoLogin<TData = SsoLogin201>(
    ssoRequestDto: SsoRequestDto,
    options?: HttpClientResponseOptions,
  ): Observable<AngularHttpResponse<TData>>;
  ssoLogin<TData = SsoLogin201>(
    ssoRequestDto: SsoRequestDto,
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(`/sso/liv`, ssoRequestDto, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      });
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(`/sso/liv`, ssoRequestDto, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      });
    }

    return this.http.post<TData>(`/sso/liv`, ssoRequestDto, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
    });
  }
  /**
   * @summary Exchange test-login email + password for a Dialab JWT
   */
  testLogin<TData = TestLogin201>(
    testLoginRequestDto: TestLoginRequestDto,
    options?: HttpClientBodyOptions,
  ): Observable<TData>;
  testLogin<TData = TestLogin201>(
    testLoginRequestDto: TestLoginRequestDto,
    options?: HttpClientEventOptions,
  ): Observable<HttpEvent<TData>>;
  testLogin<TData = TestLogin201>(
    testLoginRequestDto: TestLoginRequestDto,
    options?: HttpClientResponseOptions,
  ): Observable<AngularHttpResponse<TData>>;
  testLogin<TData = TestLogin201>(
    testLoginRequestDto: TestLoginRequestDto,
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(`/sso/test`, testLoginRequestDto, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      });
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(`/sso/test`, testLoginRequestDto, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      });
    }

    return this.http.post<TData>(`/sso/test`, testLoginRequestDto, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
    });
  }
  /**
   * @summary Whether test-login is currently open
   */
  testLoginAvailability<TData = TestLoginAvailability200>(
    options?: HttpClientBodyOptions,
  ): Observable<TData>;
  testLoginAvailability<TData = TestLoginAvailability200>(
    options?: HttpClientEventOptions,
  ): Observable<HttpEvent<TData>>;
  testLoginAvailability<TData = TestLoginAvailability200>(
    options?: HttpClientResponseOptions,
  ): Observable<AngularHttpResponse<TData>>;
  testLoginAvailability<TData = TestLoginAvailability200>(
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(`/sso/test/availability`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      });
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(`/sso/test/availability`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      });
    }

    return this.http.get<TData>(`/sso/test/availability`, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
    });
  }
  /**
   * @summary Re-issue a short-lived access token from the refresh cookie
   */
  refreshSession<TData = RefreshSession200>(options?: HttpClientBodyOptions): Observable<TData>;
  refreshSession<TData = RefreshSession200>(
    options?: HttpClientEventOptions,
  ): Observable<HttpEvent<TData>>;
  refreshSession<TData = RefreshSession200>(
    options?: HttpClientResponseOptions,
  ): Observable<AngularHttpResponse<TData>>;
  refreshSession<TData = RefreshSession200>(
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(`/sso/refresh`, undefined, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      });
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(`/sso/refresh`, undefined, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      });
    }

    return this.http.post<TData>(`/sso/refresh`, undefined, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
    });
  }
  /**
   * @summary Return the authenticated user profile
   */
  getMe<TData = GetMe200>(options?: HttpClientBodyOptions): Observable<TData>;
  getMe<TData = GetMe200>(options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
  getMe<TData = GetMe200>(
    options?: HttpClientResponseOptions,
  ): Observable<AngularHttpResponse<TData>>;
  getMe<TData = GetMe200>(
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(`/auth/me`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      });
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(`/auth/me`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      });
    }

    return this.http.get<TData>(`/auth/me`, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
    });
  }
  /**
   * @summary Persist the student onboarding answers (idempotent)
   */
  completeOnboarding<TData = CompleteOnboarding201>(
    onboardingRequestDto: OnboardingRequestDto,
    options?: HttpClientBodyOptions,
  ): Observable<TData>;
  completeOnboarding<TData = CompleteOnboarding201>(
    onboardingRequestDto: OnboardingRequestDto,
    options?: HttpClientEventOptions,
  ): Observable<HttpEvent<TData>>;
  completeOnboarding<TData = CompleteOnboarding201>(
    onboardingRequestDto: OnboardingRequestDto,
    options?: HttpClientResponseOptions,
  ): Observable<AngularHttpResponse<TData>>;
  completeOnboarding<TData = CompleteOnboarding201>(
    onboardingRequestDto: OnboardingRequestDto,
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(`/auth/me/onboarding`, onboardingRequestDto, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      });
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(`/auth/me/onboarding`, onboardingRequestDto, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      });
    }

    return this.http.post<TData>(`/auth/me/onboarding`, onboardingRequestDto, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
    });
  }
  /**
   * @summary Revoke the current session
   */
  logout<TData = Logout201>(options?: HttpClientBodyOptions): Observable<TData>;
  logout<TData = Logout201>(options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
  logout<TData = Logout201>(
    options?: HttpClientResponseOptions,
  ): Observable<AngularHttpResponse<TData>>;
  logout<TData = Logout201>(
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(`/logout`, undefined, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      });
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(`/logout`, undefined, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      });
    }

    return this.http.post<TData>(`/logout`, undefined, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
    });
  }
}

export type SsoLoginClientResult = NonNullable<SsoLogin201>;
export type TestLoginClientResult = NonNullable<TestLogin201>;
export type TestLoginAvailabilityClientResult = NonNullable<TestLoginAvailability200>;
export type RefreshSessionClientResult = NonNullable<RefreshSession200>;
export type GetMeClientResult = NonNullable<GetMe200>;
export type CompleteOnboardingClientResult = NonNullable<CompleteOnboarding201>;
export type LogoutClientResult = NonNullable<Logout201>;
